export default __webpack_public_path__ + "static/media/temple.8a1c4e47.jpeg";